// extracted by mini-css-extract-plugin
export default {"pdfDoc":"DealerTerms_pdfDoc__Mr5Gf"};